const api = {
  login: '/user/login'
}

export default api